import React from 'react';
import { LineEverywhere } from 'prophesier/dist/wrapper/index-with-deps-react.js';
import CheckBox from 'grommet/components/CheckBox';
import Box from 'grommet/components/Box';

const data = [{
    "date": "03/29/2017 10:05",
    "values": [2, 2, 1]
}, {
    "date": "03/29/2017 10:10",
    "values": [6, 2, 4]
}, {
    "date": "03/29/2017 10:15",
    "values": [6, 3, 2]
}, {
    "date": "03/29/2017 10:20",
    "values": [5, 7, 1]
}, {
    "date": "03/29/2017 10:25",
    "values": [4, 5, 2]
}, {
    "date": "03/29/2017 10:30",
    "values": [2, 2, 7]
}, {
    "date": "03/29/2017 10:35",
    "values": [3, 4, 7]
}];


const names = ["Label 1", "Label 2", "Label 3"]

const namesAssur = ["Label 1"]

const colorPrim = ["rgb(91,100,114)", "rgba(91, 100, 114, 0.25)", "rgb(86,130,216)"];
const colorPrim2 = ["rgb(86,130,216)", "rgba(91, 100, 114, 0.25)", "rgb(91,100,114)"];


class TimelineSample extends React.Component {
    constructor() {
        super();
       this.state = { 
            topvalue: true, 
            bottomvalue: true,
            maximum: false,
            minimum: false,
            barcolor: true,
            title: true,
            legends: true,
            exprt: false,
            area: false
             }
    }
    _onChange(event) {
        let { topvalue, bottomvalue,maximum,minimum,barcolor,title, legends, exprt, area } = this.state
        switch(event) {
            case "topvalue":
                this.setState({ topvalue: !topvalue })
                break;
            case "bottomvalue":
                this.setState({ bottomvalue: !bottomvalue })
                break;
            case "rotate":
                this.setState({ maximum: !maximum })
                break;
            case "stack":
                this.setState({ minimum: !minimum })
                break;
            case "barcolor":
                this.setState({ barcolor: !barcolor })
                break;
            case "title":
                this.setState({ title: !title })
                break;
            case "legends":
                this.setState({ legends: !legends })
                break;
            case "exprt":
                this.setState({ exprt: !exprt })
                break;
            case "area":
                this.setState({ area: !area })
                break;
        }
    }
    render() {
        let { topvalue, bottomvalue,maximum,stack,barcolor,title, legends, exprt, area } = this.state
        /*
                    data={this.state.data}
                    topValue={[4, 5, 4, 5, 4, 5, 4]}
                    bottomValue={[1, 2, 1, 2, 1, 2, 1]}
                    names={this.state.names}
                    topname={'XXXXXXXXXXX'}
                    bottomname={'XXXXXXXXXXX'}
                    area={false}
                    xtitle={'Time'}
                    ytitle={'Title for Y'}
                    legends={true}
                    redzoneposition={'top'}
                    customballoon={false}
                    minperiod={'5mm'}
                */
                //minimum={(minimum)? 5 : null}
        return (
            <div>
                <Box direction='row'
                    justify='center'
                    align='center'
                    wrap={true}
                    reverse={false}
                    margin='none'
                    >
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        >
                        <CheckBox 
        name='topvalue'
        id='topvalue'
        label='Top Limit'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'topvalue')}
         />
         </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        > 
         <CheckBox 
        name='bottomvalue'
        id='bottomvalue'
        label='Bottom Limit'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'bottomvalue')}
         />
         </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        > 
         <CheckBox 
        name='maximum'
        id='maximum'
        label='Maximum'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'maximum')}
         />
         </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        > 
         <CheckBox 
        name='minimum'
        id='minimum'
        label='Minimum'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'minimum')}
         />
         </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        > 
         <CheckBox 
        name='barcolor'
        id='barcolor'
        label='Color'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'barcolor')}
         />
         </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        > 
         <CheckBox 
        name='title'
        id='title'
        label='Titles'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'title')}
         />
         </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        > 
         <CheckBox 
        name='legends'
        id='legends'
        label='Legends'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'legends')}
         />
         </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        > 
         <CheckBox 
        name='exprt'
        id='exprt'
        label='Export'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'exprt')}
         />
         </Box>
                    <Box direction='row'
                        
                        align='center'
                        wrap={true}
                        pad='small'
                        margin='none'
                        > 
         <CheckBox 
        name='area'
        id='area'
        label='Area'
        toggle={true}
        disabled={false}
        reverse={true}
        onChange={this._onChange.bind(this, 'area')}
         />
         </Box>
         </Box>
                <LineEverywhere
                    data={data}
                    names={names}
                    topValue={(topvalue) ? [4, 5, 4, 5, 4, 5, 4] : []}
                    bottomValue={(bottomvalue) ? [1, 2, 1, 2, 1, 2, 1] : []}
                    topname={(topvalue)?'XXXXXXXXXXX':''}
                    bottomname={(bottomvalue) ? 'XXXXXXXXXXX': ''}
                    area={area}
                    xtitle={(title) ? 'Time' : ''}
                    ytitle={(title) ? 'Title for Y' : ''}
                    legends={legends}
                    redzoneposition={'none'}
                    customballoon={false}
                    minperiod={'5mm'}
                    maximum={(maximum)? 50 : null}
                    
                    exprt={exprt}
                    barcolor={(barcolor) ? colorPrim : colorPrim2}
                ></LineEverywhere>
            </div>
        );
    }
}

export default TimelineSample;

export const textCode = `
import React from 'react';
import { LineEverywhere } from 'prophesier/dist/wrapper/index-with-deps-react.js';

const data = [{
    "date": "03/29/2017 10:05",
    "values": [2, 2, 1]
}, {
    "date": "03/29/2017 10:10",
    "values": [6, 2, 4]
}, {
    "date": "03/29/2017 10:15",
    "values": [6, 3, 2]
}, {
    "date": "03/29/2017 10:20",
    "values": [5, 7, 1]
}, {
    "date": "03/29/2017 10:25",
    "values": [4, 5, 2]
}, {
    "date": "03/29/2017 10:30",
    "values": [2, 2, 7]
}, {
    "date": "03/29/2017 10:35",
    "values": [3, 4, 7]
}];


const names = ["Label 1", "Label 2", "Label 3"]

class TimelineSample extends React.Component {
    constructor() {
        super();
    }
    render() {
        return (
            <div>
                <LineEverywhere
                    data={this.state.data}
                    topValue={[4, 5, 4, 5, 4, 5, 4]}
                    bottomValue={[1, 2, 1, 2, 1, 2, 1]}
                    names={this.state.names}
                    topname={'XXXXXXXXXXX'}
                    bottomname={'XXXXXXXXXXX'}
                    area={false}
                    xtitle={'Time'}
                    ytitle={'Title for Y'}
                    legends={true}
                    redzoneposition={'top'}
                    customballoon={false}
                    minperiod={'5mm'}
                ></LineEverywhere>
            </div>
        );
    }
}

export default TimelineSample;
`





export const src = `
const data = [{
    "date": "03/29/2017 10:00",
    "values": [2, 2, 1]
}, {
    "date": "03/29/2017 11:00",
    "values": [5, 2, 3]
}, {
    "date": "03/29/2017 12:00",
    "values": [4, 3, 2]
}, {
    "date": "03/29/2017 13:00",
    "values": [3, 5, 1]
}, {
    "date": "03/29/2017 14:00",
    "values": [4, 3, 2]
}, {
    "date": "03/29/2017 15:00",
    "values": [2, 2, 5]
}, {
    "date": "03/29/2017 16:00",
    "values": [3, 4, 2]
}];
const names = ["Label 1", "Label 2", "Label 3"]

const template = "<line-everywhere ></line-everywhere>";

document.onreadystatechange = () => {
    if (document.readyState === "complete") {
        const sampleCode  = document.querySelector("._sampleDomElement");
        sampleCode.innerHTML = template
        const element = document.querySelector("line-everywhere")
        element.data = data;
        element.names = names;
        element.topValue = [4, 5, 4, 5, 4, 5, 4];
        element.bottomValue = [1, 2, 1, 2, 1, 2, 1];
        element.topname = 'Top Value Threshold';
        element.bottomname = 'Bottom Value Threshold',
        element.tooltiptext = '[[title]]: [[value]]%'
        element.xtitle = "Title for X";
        element.ytitle = "Title for Y";
    }
}

`



// WEBPACK FOOTER //
// ./src/samples/TimelineTHomeReact.js